(function () {
  Array.prototype.forEach.call(document.querySelectorAll('.sc-logbox img, .sc-cta-sam img'), function (i) { i.loading = 'eager'; });
})();
(function () {
  var card = document.querySelector('[data-sc-apv]');
  if (!card) return;
  var root = card.closest('.sc-demo');
  var list = card.querySelector('[data-sc-lines]');
  var res = card.querySelector('[data-sc-res]');
  var ICON = { sparkles: 'sparkles', user: 'user', check: 'check', x: 'x-circle', clock: 'clock', warn: 'alert-triangle', retry: 'refresh' };
  var RES_ICON = { ok: 'check-circle', no: 'x-circle', ex: 'clock', fail: 'alert-triangle' };
  var failNext = false;

  function line(kind, text, time) {
    var li = document.createElement('li');
    li.innerHTML = '<svg class="os-icon os-icon--14" aria-hidden="true"><use href="#i-' + ICON[kind] + '"/></svg><span></span><time></time>';
    li.querySelector('span').textContent = text;
    li.querySelector('time').textContent = time;
    list.appendChild(li);
  }
  function say(kind, text) {
    res.setAttribute('data-kind', kind);
    res.innerHTML = '<svg class="os-icon" aria-hidden="true"><use href="#i-' + RES_ICON[kind] + '"/></svg><span></span>';
    res.querySelector('span').textContent = text;
  }
  function setState(st, focusSel) {
    card.setAttribute('data-state', st);
    var f = focusSel && card.querySelector(focusSel);
    if (f) f.focus();
  }
  function reset() {
    list.textContent = '';
    res.setAttribute('data-kind', ''); res.textContent = '';
    line('sparkles', 'Reminder drafted by Nora', '9:42 AM');
    line('clock', 'Waiting for approval', '9:42 AM');
    setState('pending');
  }
  function approve() {
    line('user', 'Approved by Dana', '9:44 AM');
    if (failNext) {
      failNext = false;
      line('warn', 'The send failed. The approval stays on record', '9:44 AM');
      say('fail', 'Approved by Dana, but the send failed. Retry runs the same approved action. It does not ask again and cannot send twice.');
      setState('failed', '[data-do="retry"]');
    } else {
      line('check', 'Reminder sent to Brooks Plumbing, once', '9:44 AM');
      say('ok', 'Approved by Dana. Reminder sent once.');
      setState('approved', '[data-do="again"]');
    }
  }
  function act(what) {
    var st = card.getAttribute('data-state');
    if (what === 'again') { failNext = false; reset(); var b = card.querySelector('[data-do="approve"]'); if (b) b.focus(); return; }
    if (what === 'fail') { reset(); failNext = true; approve(); return; }
    if (what === 'expire') {
      reset(); line('clock', 'Expired after 60 minutes. Nothing sent', '10:42 AM');
      say('ex', 'Expired after 60 minutes with no answer. Nothing was sent.');
      setState('expired', '[data-do="again"]'); return;
    }
    if (what === 'approve' && st === 'pending') { approve(); return; }
    if (what === 'reject' && st === 'pending') {
      line('x', 'Rejected by Dana. Nothing sent', '9:44 AM');
      say('no', 'Rejected by Dana. Nothing was sent, and the draft stays on the record.');
      setState('rejected', '[data-do="again"]'); return;
    }
    if (what === 'retry' && st === 'failed') {
      line('retry', 'Retry started. No second approval, no duplicate', '9:46 AM');
      line('check', 'Reminder sent to Brooks Plumbing, once', '9:46 AM');
      say('ok', 'The retry worked. Reminder sent once, with no duplicate.');
      setState('retried', '[data-do="again"]');
    }
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-do]');
    if (b && root.contains(b)) act(b.getAttribute('data-do'));
  });
  reset();
})();;
(function () {
  var box = document.querySelector('[data-sc-log]');
  if (!box) return;
  var cat = box.querySelector('[data-sc-cat]');
  var empty = box.querySelector('[data-sc-empty]');
  var rows = Array.prototype.slice.call(box.querySelectorAll('tbody tr'));
  function apply() {
    var c = cat.value, shown = 0;
    rows.forEach(function (r) {
      var ok = c === 'all' || (' ' + r.getAttribute('data-cats') + ' ').indexOf(' ' + c + ' ') >= 0;
      r.hidden = !ok;
      if (ok) shown++;
    });
    empty.hidden = shown !== 0;
  }
  cat.addEventListener('change', apply);
  apply();
})();
